import { selectJsonQuery } from '../results';
import { getIsEtazhiBlackFridayFilterEnabled } from 'shared/utils/etazhiBlackFriday';

import type { IAppState } from 'shared/common/state';

export const selectIsEtazhiBlackFridayFilterEnabled = (state: IAppState): boolean => {
  const jsonQuery = selectJsonQuery(state);

  return getIsEtazhiBlackFridayFilterEnabled(jsonQuery);
};
